import MuiMenu, { MenuProps } from '@mui/material/Menu';

export interface IMenuProps extends MenuProps {}

const Menu = (props: IMenuProps): JSX.Element => {
  return <MuiMenu {...props} />;
};

export default Menu;
